import React from 'react';
import styled from 'styled-components';
import { theme } from '../styles/GlobalStyles';

interface SectionProps {
  variant?: 'default' | 'primary' | 'secondary' | 'light';
  padding?: 'none' | 'small' | 'medium' | 'large';
  maxWidth?: string;
}

const getVariantStyles = (variant: SectionProps['variant']) => {
  switch (variant) {
    case 'primary':
      return `
        background-color: ${theme.colors.primary};
        color: white;
      `;
    case 'secondary':
      return `
        background-color: ${theme.colors.secondary};
        color: white;
      `;
    case 'light':
      return `
        background-color: ${theme.colors.lightGray};
      `;
    default:
      return '';
  }
};

const getPaddingStyles = (padding: SectionProps['padding']) => {
  switch (padding) {
    case 'none':
      return 'padding: 0;';
    case 'small':
      return `padding: ${theme.spacing.md} 0;`;
    case 'medium':
      return `padding: ${theme.spacing.lg} 0;`;
    case 'large':
      return `padding: ${theme.spacing.xl} 0;`;
    default:
      return `padding: ${theme.spacing.lg} 0;`;
  }
};

const StyledSection = styled.section<SectionProps>`
  width: 100%;
  ${({ variant = 'default' }) => getVariantStyles(variant)}
  ${({ padding = 'medium' }) => getPaddingStyles(padding)}
`;

const SectionContent = styled.div<{ maxWidth?: string }>`
  width: 100%;
  max-width: ${({ maxWidth = '1200px' }) => maxWidth};
  margin: 0 auto;
  padding: 0 ${theme.spacing.md};
`;

export const Section: React.FC<SectionProps & React.HTMLAttributes<HTMLElement>> = ({
  children,
  variant = 'default',
  padding = 'medium',
  maxWidth = '1200px',
  ...props
}) => {
  return (
    <StyledSection variant={variant} padding={padding} {...props}>
      <SectionContent maxWidth={maxWidth}>{children}</SectionContent>
    </StyledSection>
  );
}; 